// My Events client (attendee saving / attending), ported into the /opt tree.
//
// Reuses the existing Bearer-token API service (`@/services/api`) — the same
// client the rest of the app uses. Paths are unprefixed; the service prepends
// REACT_APP_BACKEND_URL (`/api`). All endpoints are Bearer-authenticated via
// the backend's get_current_user.
//
// Backend collection: db.user_events. A record's `event_id` is the catalog
// event's stable `id` (e.g. "7"), `status` is "saved" | "attending", and
// `self_confirmed` flips to true once the user confirms attendance.
import api from '@/services/api';

export const myEvents = {
  list: () => api.get('/users/me/events'),
  add: (eventId) => api.post(`/users/me/events/${encodeURIComponent(eventId)}`),
  confirm: (eventId) => api.post(`/users/me/events/${encodeURIComponent(eventId)}/confirm`),
  remove: (eventId) => api.del(`/users/me/events/${encodeURIComponent(eventId)}`),
};

export default myEvents;
